module.exports = __webpack_public_path__ + "static/media/CERTIFICADO DE ACCESIBILIDAD.158aaaf6.pdf";